import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import { browserHistory } from 'react-router';

class InstructionAudioFormService {
  form = new FormService();
  fetch = new FetchService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      instructionAudioId: null,
    });
    this.form.validations = {
      type: [isRequired],
      key: [isRequired],
    };
  }

  handleLoad = action(async (instructionAudioId) => {
    this.form.reset();
    this.form.setInitialValues({});
    this.instructionAudioId = instructionAudioId;

    if (instructionAudioId) {
      await this.fetch.fetch({ url: `/instruction-audios/${instructionAudioId}` });
      if (this.fetch.data) {
        this.form.setInitialValues(this.fetch.data);
      }
    }

    const locales = await this.fetch.fetch({
      url: '/locales',
    });

    this.form.setInitialValues({
      ...this.form.getValues(),
      instructions: locales.map((locale) => {
        const instruction = (this.form.getValue('instructions') || []).find(
          (instruction) => instruction.locale === locale.key
        );
        return {
          locale: locale.key,
          text: (instruction && instruction.text) || '',
          audio: (instruction && instruction.audio) || '',
        };
      }),
    });
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    const formData = new FormData();
    Object.keys(this.form.getValue('audios')).map((locale) =>
      formData.append(`audio-${locale}`, this.form.getValue('audios')[locale])
    );
    formData.append(`instructions`, JSON.stringify(this.form.getValue('instructions')));
    formData.append('key', this.form.getValue('key'));
    formData.append('type', this.form.getValue('type'));

    this.submit
      .fetch({
        method: this.instructionAudioId ? 'put' : 'post',
        url: this.instructionAudioId ? `/instruction-audios/${this.instructionAudioId}` : `/instruction-audios`,
        body: formData,
      })
      .then(() => {
        if (this.submit.data) {
          browserHistory.push('/instruction-audios');
          NotificationService.addNotification(
            `Instruction Audio ${this.instructionAudioId ? 'updated' : 'created'} successfully.`,
            'success'
          );
        }
        if (this.submit.error) {
          NotificationService.addNotification(
            `Error ${this.instructionAudioId ? 'updating' : 'creating'} Instruction Audio.`,
            'error'
          );
        }
      });
  });

  handleAudioDownload = (filePath) => {
    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_FILES_URL}/${filePath}`;

    link.download = filePath.split('/').pop();
    link.click();
    setTimeout(() => window.URL.revokeObjectURL(filePath, 500));
  };
}

export default InstructionAudioFormService;
